

export const WEPAY_FETCH      = 'WEPAY_FETCH'; //request payment JSAPI data
export const WEPAY_REQUEST    = 'WEPAY_REQUEST'; //request payment JSAPI data
export const WEPAY_SUCCESS    = 'WEPAY_SUCCESS'; //effect successfully
export const WEPAY_FAIL       = 'WEPAY_FAIL';    //fail to pay 
export const WEPAY_CANCEL     = 'WEPAY_CANCEL';  //cancel to pay
